import { useEffect, useRef, useState } from "react"
import { twMerge } from "tailwind-merge"
import { EditableText } from "eddev/blocks"
import { Button } from "@components/ui/Button"

export const Video = ({
  src,
  className,
  videoType,
}: {
  src?: string | null
  className?: string
  videoType?: string
}) => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const [showPlayButton, setShowPlayButton] = useState(true)
  const getYoutubeEmbedUrl = (url: string) => {
    const videoId = url.split("v=")[1]
    return `https://www.youtube.com/embed/${videoId}?color=white&modestbranding=1&rel=0&showinfo=0`
  }

  useEffect(() => {
    if (videoType === "upload" && videoRef.current) {
      videoRef.current.load()
    }
  }, [])

  return (
    <div className="w-full aspect-video bg-grey-1 overflow-hidden">
      {videoType === "upload" && src && (
        <div className="w-full h-full relative">
          <video
            ref={videoRef}
            className="w-full h-full object-cover"
            src={src}
            controls={!showPlayButton}
            onPlaying={() => setShowPlayButton(false)}
            onPause={() => setShowPlayButton(true)}
            onEnded={() => setShowPlayButton(true)}
          />
          {showPlayButton && (
            <Button
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
              onClick={() => videoRef?.current?.play().catch(() => {})}
            >
              <EditableText
                as="span"
                store="video-play-button"
                inlineToolbar={false}
                defaultValue={"Play video"}
                placeholder={"Play video"}
                plainText
              />
            </Button>
          )}
        </div>
      )}
      {videoType === "youtube" && src && (
        <iframe
          className="w-full h-full"
          src={getYoutubeEmbedUrl(src)}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      )}
    </div>
  )
}
